function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created using Figma");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-8274 -4926)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_fill",
  transform: "translate(8274 4926)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path1_fill",
  transform: "translate(8286.77 4972.29)",
  fill: "#E21839"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "translate(8275.94 4927.99)",
  fill: "#E21839"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path3_fill",
  transform: "translate(8374.43 4961.07)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path4_fill",
  transform: "translate(8417.88 4961.07)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(8456.67 4961.26)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path6_fill",
  transform: "translate(8491.3 4961.26)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(8534.46 4962.14)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path8_fill",
  transform: "translate(8584.26 4961.26)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path9_fill",
  transform: "translate(8623.15 4962.14)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path10_fill",
  transform: "translate(8672.57 4943.92)",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path11_fill",
  transform: "translate(8695.33 4962.14)",
  fill: "#FFFFFF"
})))));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_fill",
  d: "M 78.8065 17.3413C 75.6762 6.97526 62.3962 0 45.6065 0C 42.6659 0 39.6305 0.193757 36.5951 0.678151C 22.5562 2.7126 10.2248 9.30035 4.34362 17.8257L 4.15391 18.1163C 3.67962 18.7945 3.30019 19.4726 2.92076 20.2476L 2.92076 20.3445C 2.1619 21.7977 1.59276 23.2509 1.21333 24.8009C -1.53753 34.5857 0.454475 47.7612 6.52534 59.871C 12.7859 72.2715 22.2716 81.5718 31.8522 84.8657C 33.5596 85.5439 35.4568 85.9314 37.3539 86.0283L 37.7334 86.0283C 37.8282 86.0283 38.0179 86.0283 38.1128 86.0283C 38.3025 86.0283 38.5871 86.0283 38.7768 86.0283C 40.4842 86.0283 42.0968 85.8345 43.6145 85.3501C 54.4282 82.6375 65.8111 72.1746 73.21 58.1272C 80.6088 43.6923 82.7905 28.0948 78.8065 17.3413Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1_fill",
  d: "M 63.0039 0.344181C 48.301 20.1074 37.013 26.7921 23.2587 28.0515C 14.7216 28.8265 6.8484 24.8545 0.587824 19.623C 0.113538 19.1386 -0.171033 19.3324 0.113538 19.9137C 5.89983 28.5359 13.2987 34.6392 20.3181 36.9643C 21.8358 37.5456 23.5433 37.9331 25.2507 38.03C 25.3456 38.03 25.3456 38.03 25.4404 38.03C 25.6301 38.03 25.725 38.03 25.9147 38.03C 27.6221 38.1269 29.3296 37.9331 30.8473 37.3518C 40.8073 34.833 51.8107 25.1451 59.2096 11.0977C 61.0119 7.61008 62.5296 4.12245 63.6679 0.634816C 63.8576 -0.0433346 63.4782 -0.237091 63.0039 0.344181Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2_fill",
  d: "M 28.6809 61.4678C 36.7437 60.5959 45.7552 58.949 60.2683 48.0017C 64.8215 44.5141 75.9198 35.8919 76.7735 29.9823C 77.058 24.7508 76.4889 20.0038 74.9712 16.0317C 71.6512 4.69693 54.482 -2.18145 35.0363 0.628028C 20.9974 2.66248 9.42484 9.15335 4.01798 17.0974C 3.92312 17.1943 3.92312 17.1943 3.82826 17.2912C 3.44883 17.9693 3.0694 18.5506 2.68998 19.2287L 2.59512 19.3256C 1.93112 20.6819 1.36197 21.9413 1.0774 23.3945C -0.914599 30.6604 -0.155742 40.4452 3.44883 50.3268C 6.76884 59.2396 20.0488 62.4366 28.6809 61.4678Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3_fill",
  d: "M 1.44741e-06 29.9355C 1.44741e-06 21.5071 6.54516 16.9538 22.0069 15.3068C 21.8172 11.7223 20.1097 9.49411 15.8412 9.49411C 12.5212 9.49411 9.296 10.8504 5.50172 13.0786L 1.328 5.23145C 6.26058 2.13133 11.952 7.39126e-07 18.0229 7.39126e-07C 28.0777 7.39126e-07 33.5795 5.81272 33.5795 18.0194L 33.5795 40.8828L 24.0937 40.8828L 23.3349 36.8139L 23.0503 36.8139C 19.7303 39.8171 16.1257 41.8516 11.6674 41.8516C 4.55314 42.0453 1.44741e-06 36.717 1.44741e-06 29.9355ZM 22.0069 29.4511L 22.0069 22.4759C 13.7543 23.6384 11.0983 26.0604 11.0983 29.0636C 11.0983 31.6793 12.8057 32.8419 15.5566 32.8419C 18.3074 32.8419 20.0149 31.5824 22.0069 29.4511Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path4_fill",
  d: "M -2.89481e-06 1.06566L 11.5726 1.06566L 11.5726 15.7912L 15.5566 15.7912L 18.9714 8.42845C 22.0069 1.64694 25.8012 7.39126e-07 31.3977 7.39126e-07C 32.536 7.39126e-07 33.4846 0.193757 34.528 0.581271L 32.7257 11.5286C 32.2515 11.3348 31.7772 11.2379 31.208 11.2379C 29.216 11.2379 27.6983 11.8192 26.2754 15.3068L 24.1886 20.0539L 37.3738 40.9797L 24.6629 40.9797L 15.6514 24.9947L 11.5726 24.9947L 11.5726 40.9797L -2.89481e-06 40.9797L -2.89481e-06 1.06566Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path5_fill",
  d: "M 5.78963e-06 20.9258C 5.78963e-06 7.65342 9.58059 1.47825e-06 20.3943 1.47825e-06C 25.232 1.47825e-06 28.9315 1.74382 31.872 4.26266L 26.4652 11.9161C 24.568 10.2691 22.9554 9.59099 21.1532 9.59099C 15.5566 9.59099 11.952 14.0474 11.952 20.9258C 11.952 27.9011 15.6514 32.2606 20.6789 32.2606C 23.24 32.2606 25.6115 31.0012 27.6983 29.3542L 32.2515 37.1045C 28.3623 40.5922 23.5246 41.8516 19.3509 41.8516C 8.44229 41.8516 5.78963e-06 34.1982 5.78963e-06 20.9258Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path6_fill",
  d: "M 5.78963e-06 20.9258C 5.78963e-06 7.94405 9.1063 1.47825e-06 18.4972 1.47825e-06C 29.5955 1.47825e-06 35.1921 8.33157 35.1921 19.182C 35.1921 21.3133 34.9075 23.4446 34.7178 24.4134L 11.288 24.4134C 12.3314 30.2261 16.2206 32.8419 21.4377 32.8419C 24.3783 32.8419 27.0343 31.97 29.88 30.2261L 33.7692 37.3952C 29.7852 40.2046 24.568 41.9485 19.92 41.9485C 8.63202 41.8516 5.78963e-06 34.1013 5.78963e-06 20.9258ZM 25.232 16.5663C 25.232 12.1098 23.3349 9.00972 18.6869 9.00972C 15.0823 9.00972 11.8572 11.5286 11.0983 16.5663L 25.232 16.5663Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path7_fill",
  d: "M 5.78963e-06 -7.39126e-07L 13.28 -7.39126e-07L 18.2126 13.6599C 19.256 16.8569 20.1097 19.7633 20.9635 22.5727L 21.248 22.5727C 22.1966 19.7633 23.1452 16.8569 24.0937 13.6599L 28.6469 -7.39126e-07L 41.8321 -7.39126e-07L 41.8321 40.0109L 31.5875 40.0109L 31.5875 29.7418C 31.5875 25.4791 32.3463 17.0506 32.7257 12.4974L 32.4412 12.4974C 31.3029 16.0819 29.7852 20.3445 28.6469 23.7353L 24.0937 36.5233L 17.7383 36.5233L 13.0903 23.7353C 11.952 20.3445 10.3394 15.8881 9.20114 12.4974L 8.91658 12.4974C 9.29601 17.0506 10.1497 25.4791 10.1497 29.7418L 10.1497 40.0109L 5.78963e-06 40.0109L 5.78963e-06 -7.39126e-07Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path8_fill",
  d: "M 5.78963e-06 20.9258C 5.78963e-06 7.94405 9.1063 1.47825e-06 18.4972 1.47825e-06C 29.5955 1.47825e-06 35.1921 8.33157 35.1921 19.182C 35.1921 21.3133 35.0023 23.4446 34.7178 24.4134L 11.288 24.4134C 12.3314 30.2261 16.2206 32.8419 21.4377 32.8419C 24.3783 32.8419 27.0343 31.97 29.88 30.2261L 33.7692 37.3952C 29.7852 40.2046 24.568 41.9485 19.92 41.9485C 8.63202 41.8516 5.78963e-06 34.1013 5.78963e-06 20.9258ZM 25.232 16.5663C 25.232 12.1098 23.3349 9.00972 18.6869 9.00972C 15.0823 9.00972 11.8571 11.5286 11.0983 16.5663L 25.232 16.5663Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path9_fill",
  d: "M 11.1931 53.8645L 1.13828 53.8645L 5.78963e-06 38.4608L 5.78963e-06 30.7105L 2.4663 30.7105C 4.36345 29.6449 5.69143 27.126 7.01944 15.8881L 8.82172 -7.39126e-07L 38.0378 -7.39126e-07L 38.0378 30.7105L 44.2983 30.7105L 44.2983 38.4608L 43.1601 53.8645L 33.2 53.8645L 33.2 40.0109L 11.0983 40.0109L 11.0983 53.8645L 11.1931 53.8645ZM 13.8492 30.7105L 26.4652 30.7105L 26.4652 9.30035L 18.1177 9.30035L 17.0743 18.6007C 16.5052 23.8322 15.3669 27.8042 13.8492 30.7105Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path10_fill",
  d: "M 1.15793e-05 6.10336C 1.15793e-05 2.51884 2.84571 0 6.73485 0C 10.7189 0 13.4697 2.51884 13.4697 6.10336C 13.4697 9.68787 10.7189 12.3036 6.73485 12.3036C 2.84571 12.4005 1.15793e-05 9.78475 1.15793e-05 6.10336ZM 0.948584 18.2132L 12.5211 18.2132L 12.5211 58.2241L 0.948584 58.2241L 0.948584 18.2132Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path11_fill",
  d: "M 1.15793e-05 -7.39126e-07L 11.5726 -7.39126e-07L 11.5726 14.4349L 24.0937 14.4349L 24.0937 -7.39126e-07L 35.6663 -7.39126e-07L 35.6663 40.0109L 24.0937 40.0109L 24.0937 24.8009L 11.5726 24.8009L 11.5726 40.0109L 1.15793e-05 40.0109L 1.15793e-05 -7.39126e-07Z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 90,
    viewBox: "0 0 457 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d29fe9fbb51d133323227cee2c1377da.svg";
export { ForwardRef as ReactComponent };